import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Cuándo estará disponible la aplicación?",
    answer: "Estamos en fase final de desarrollo. Si te registras en la lista de espera, recibirás acceso prioritario."
  },
  {
    question: "¿Taxby sirve para cualquier tipo de autónomo?",
    answer: "Sí. Está especialmente optimizado para autónomos en régimen de estimación directa."
  },
  {
    question: "¿Qué tipo de soporte ofrece Taxby?",
    answer: "Disponemos de atención por correo electrónico y gestores especializados en fiscalidad autónoma. Los tiempos de respuesta varían según el plan contratado."
  },
  {
    question: "¿Puedo migrar desde mi gestoría actual sin perder datos?",
    answer: "Sí. Nuestro equipo se encarga de facilitar la migración de manera segura y sin interrupciones."
  },
  {
    question: "¿Mis datos están protegidos?",
    answer: "Sí. Taxby cumple con el Reglamento General de Protección de Datos (RGPD) y utiliza protocolos de seguridad de nivel empresarial."
  }
];

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-gray-50 relative">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-taxby-violet mb-6">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="bg-white rounded-lg shadow-sm border border-gray-100 px-6"
              >
                <AccordionTrigger className="text-left text-lg font-medium text-taxby-violet py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
      
      {/* Background shape */}
      <div className="absolute -bottom-10 -left-10 h-64 w-64 bg-taxby-purple/5 rounded-full -z-10"></div>
    </section>
  );
};

export default FAQ;
